const publishedMainUrl = '/view-report/:student_id/:console_id/:type/:template_view/:asset_format/:selected_year/:kb_consolidated/:kg_consolidated/:montessori_consolidated/:for_ct' ;
export default [{
        name: 'login',
        url: '/',
        component: 'login'
    },
    {
        name: 'home',
        url: '/home',
        component: 'home'
    }, {
        name: 'user',
        url: '/user',
        component: 'user'
    },
    {
        name: 'navigation',
        url: '/navigation',
        component: 'navigation'
    },
    {
        name: 'teacherView',
        url: '/teacherView',
        component: 'teacherView'
    },
    {
        name: 'commonChart',
        url: '/commonChart',
        component: 'commonChart'
    },
    {
        name: 'ssbdForm',
        url: '/ssbdForm',
        component: 'ssbdForm'
    },
    {
        name: 'pbslpForm',
        url: '/pbslpForm',
        component: 'pbslpForm'
    },
    {
        name: 'switForm',
        url: '/switForm',
        component: 'switForm'
    },
    {
        name: 'parentConsentForm',
        url: '/parentConsentForm',
        component: 'parentConsentForm'
    },
    {
        name: 'senRefferalForm',
        url: '/senRefferalForm',
        component: 'senRefferalForm'
    },
    {
        name: 'sendAccomodation',
        url: '/sendAccomodation',
        component: 'sendAccomodation'
    },
    {
        name: 'historyIep',
        url: '/historyIep',
        component: 'historyIep'
    },
    {
        name: 'historyIlp',
        url: '/historyIlp',
        component: 'historyIlp'
    },
    {
        name: 'iepParentComment',
        url: '/iepParentComment',
        component: 'iepParentComment'
     },
     {
        name: 'sendBuddy',
        url: '/sendBuddy',
        component: 'sendBuddy'
     }
    , {
        name: 'icesKgForm',
        url: '/icesKgForm',
        component: 'icesKgForm'
     },
     {
        name: 'icesFirstgrade',
        url: '/icesFirstgrade',
        component: 'icesFirstgrade'
     },
     {
        name: 'icesTwosix',
        url: '/icesTwosix',
        component: 'icesTwosix'
     }, {
        name: 'icesAboveSix',
        url: '/icesAboveSix',
        component: 'icesAboveSix'
     },
     {
        name: 'icesParentConsentForm',
        url: '/icesParentConsentForm',
        component: 'icesParentConsentForm'
     }
    /* {
        name: 'commonFilter',
        url: '/commonFilter',
        component: 'commonFilter'
    } */
    ,
    {
        name: 'viewGeneratedReportData',
        url: '/view-genareted-report/:dataId/:selected_year/:is_edit',
        component: 'viewGeneratedReportData'
     },
     {
        name: 'typeFourMarkComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeFourMarkComponent'
     },
     {
        name: 'typeFourAnnualComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeFourAnnualComponent'
     },
     {
        name: 'typeOneMarkComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeOneMarkComponent'
     },
     {
        name: 'typeTwoMarkComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeTwoMarkComponent'
     },
     {
        name: 'typeThreeSubSkillComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeThreeSubSkillComponent'
     },
     {
        name: 'typeSkillOnlyComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeSkillOnlyComponent'
     },

     {
        name: 'typeOneGradeComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'typeOneGradeComponent'
     },
     {
        name: 'periodicTestDefaultHfComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'periodicTestDefaultHfComponent'
     },
     {
        name: 'periodicTestDefaultAnnualComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'periodicTestDefaultAnnualComponent'
     },
     {
        name: 'periodicTestDefaultHfTwoComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'periodicTestDefaultHfTwoComponent'
     },
     {
        name: 'periodicTestDefaultAnnualTwoComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'periodicTestDefaultAnnualTwoComponent'
     },
     {
        name: 'hssTemplateComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'hssTemplateComponent'
     },
     {
        name: 'cbsehssComponent',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'cbsehssComponent'
     },
     {
        name: 'termonehalfyearlyComp',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'termonehalfyearlyComp'
     },
     {
        name: 'kbhfhssComp',
        url: '/view-genareted-report/:dataId/:selected_year',
        component: 'kbhfhssComp'
     },
     {
      name: 'gradeNineComp',
      url: '/view-genareted-report/:dataId/:selected_year',
      component: 'gradeNineComp'
   },
     {
      name: 'reportsMain',
      url: publishedMainUrl,
      component: 'reportsMainComponent'
   },
   {
      name: 'typeOneHfComponent',
      url: publishedMainUrl,
      component: 'typeOneHfComponent'
   },
   {
      name: 'periodicTestDefaultHfPublished',
      url: publishedMainUrl,
      component: 'periodicTestDefaultHfPublished'
   },
   {
      name: 'periodicTestDefaultAnnualPublished',
      url: publishedMainUrl,
      component: 'periodicTestDefaultAnnualPublished'
   },
   {
      name: 'defaultYearEnd',
      url: publishedMainUrl,
      component: 'defaultYearEnd'
   },
   {
      name: 'termConsolidated',
      url: publishedMainUrl,
      component: 'termConsolidated'
   },
   {
      name: 'educoreYearEnd',
      url: publishedMainUrl,
      component: 'educoreYearEnd'
   },
   {
      name: 'skilSubSkill',
      url: publishedMainUrl,
      component: 'skilSubSkill'
   },
   {
      name: 'assetHfComponent',
      url: publishedMainUrl,
      component: 'assetHfComponent'
   },
   {
      name: 'assetAnnualComponent',
      url: publishedMainUrl,
      component: 'assetAnnualComponent'
   },
   {
      name: 'kgTerms',
      url: publishedMainUrl,
      component: 'kgTerms'
   },
   {
      name: 'periodicTestDefaultHfTwoPublished',
      url: publishedMainUrl,
      component: 'periodicTestDefaultHfTwoPublished'
   },
   {
      name: 'periodicTestDefaultAnnualTwoPublished',
      url: publishedMainUrl,
      component: 'periodicTestDefaultAnnualTwoPublished'
   },
   {
      name: 'kgConsolidated',
      url: publishedMainUrl,
      component: 'kgConsolidated'
   },
   {
      name: 'kbTerms',
      url: publishedMainUrl,
      component: 'kbTerms'
   },
   {
      name: 'hssComponent',
      url: publishedMainUrl,
      component: 'hssComponent'
   },
   {
      name: 'cbseHssPublishedComponent',
      url: publishedMainUrl,
      component: 'cbseHssPublishedComponent'
   },
   {
      name: 'specificHf',
      url: publishedMainUrl,
      component: 'specificHf'
   },
   {
      name: 'kbhfhsspublishedComp',
      url: publishedMainUrl,
      component: 'kbhfhsspublishedComp'
   },
   {
      name: 'cbseSpecificSubjectsFinalComp',
      url: publishedMainUrl,
      component: 'cbseSpecificSubjectsFinalComp'
   },
   {
      name: 'userConsole',
      url: '/userConsole',
      component: 'userConsole'
   },
   {
      name: 'csvUploadCtrl',
      url: '/userConsole',
      component: 'csvUploadCtrl'
   },
   {
      name: 'academicConsole',
      url: '/academicConsole',
      component: 'academicConsole'
   },
   {
      name: 'addSubject',
      url: '/userConsole',
      component: 'addSubject'
   }
];


// WEBPACK FOOTER //
// ./src/services/router-helper/app-routes.js